import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import CreditSection from './components/CreditSection';
import ToolsSection from './components/ToolsSection';
import InsightsSection from './components/InsightsSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import WhyChooseSection from './components/WhyChooseSection';
import Footer from './components/Footer';
import ComingSoonPopup from './components/ComingSoonPopup';
import './App.css';

function App() {
  return (
    <div className="App">
      <ComingSoonPopup />
      <Navbar />
      <Hero />
      <ProductSection />
      <CreditSection />
      <ToolsSection />
      <InsightsSection />
      <Testimonials />
      <CTASection 
        title="Ready to Transform Your Workflow?"
        variant="primary"
      />
      <WhyChooseSection />
      <CTASection 
        title="Everything You Need for Interior Solutions — In One Place."
        description="Join thousands of businesses already using our platform to streamline operations and drive growth."
        variant="secondary"
      />
      <Footer />
    </div>
  );
}

export default App;

